import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
//
import Login from './pages/Login';
import Logout from './pages/Logout';
import Register from './pages/Register';
import DashboardApp from './pages/DashboardApp';
import Products from './pages/Products';
import Blog from './pages/Blog';
import Users from './pages/Users';
import User from './pages/User';
import NotFound from './pages/Page404';
import Ranking from './pages/Ranking';
import UserMgmt from './pages/UserMgmt';
import Notification from './pages/Notification';
import AddUser from './pages/AddUser';
import Video from './pages/Video';
import Layout  from './layouts/my/Index';
import { Branding, BrandingOptions } from './components/common/Constants';
// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" replace /> },
        { path: 'app', element: <DashboardApp /> },
        { path: 'user',
          children: [
  
            { path:'', element: <Users></Users>},
            { path:':id', element: <User></User>},
            { path:'addUser', element: <AddUser></AddUser>}
          ]
        },
        { path: 'users',
          children: [

            { path:'', element: <UserMgmt></UserMgmt>},
            { path:':q', element: <UserMgmt></UserMgmt>},
            { path:'add', element: <AddUser></AddUser>},
            { path:'edit/:id', element: <User></User>},
          ]
        },
        { path: 'user/:id', element: <User /> },
        { path: 'products', element: <Products /> },
        { path: 'blog', element: <Blog /> },
        { path: 'ranking', element: <Ranking /> },
        { path: 'notification', element: <Notification /> },
        { path: 'video', element: <Video /> },
      ]
    },
    {
      path: '/my',
      element: <Layout />,
      children: [
        { element: <Navigate to="/my/video" replace /> },
        { path: 'app', element: <DashboardApp /> },
        { path: 'user/:id', element: <User /> },
        { path: 'products', element: <Products /> },
        { path: 'blog', element: <Blog /> },
        { path: 'ranking', element: <Ranking /> },
        { path: 'notification', element: <Notification /> },
        { path: 'video', element: <Video /> },
      ]
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: 'login', element: <Login /> },
        { path: 'logout', element: <Logout /> },
        { path: 'register', element: <Register /> },
        { path: '404', element: <NotFound /> },
        
       // ,
       Branding == BrandingOptions.Sonnentherme ? { path: '/', element: <Navigate to="/dashboard/app" /> } : { path: '/', element: <Navigate to="/my/video" /> },

        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}
